<div class="wrap" [class.full-width]="isFullWidth">
  <ng-content></ng-content>
  <button
    cignaButton="tertiary small"
    type="button"
    (click)="toggleVisibility()"
  >
    <ng-leaf-icon-next
      *ngIf="!isPasswordVisible"
      name="visibility-false"
      category="system"
      weight="regular"
      size="24"
      ariaLabel="show password"
    ></ng-leaf-icon-next>
    <ng-leaf-icon-next
      *ngIf="isPasswordVisible"
      name="visibility-true"
      category="system"
      weight="regular"
      size="24"
      ariaLabel="hide password"
    ></ng-leaf-icon-next>
  </button>
</div>
